import ReactDOM from 'react-dom';
import React from 'react';
import {createBrowserHistory} from "history";
import {Provider} from 'react-redux';
import {bindActionCreators} from 'redux';
import initStore from 'config/store';
import {setupAxiosInterceptors} from 'rest/axios';
import { ConnectedRouter } from "connected-react-router";
import DevTools from 'config/devtools';
import getRoutes from 'router/router';
import {registerLocales} from 'config/translation';
import 'style/gui.css';
import 'style/main.css';
import 'style/main.less'
const devTools = process.env.NODE_ENV === 'development' ? <DevTools/> : null;

export const history = process.env.NODE_ENV === 'development' ? createBrowserHistory():createBrowserHistory({
  getUserConfirmation: (message, callback) =>{
    // Show some custom dialog to the user and call
    // callback(true) to continue the transiton, or
    // callback(false) to abort it.
    if(message === "") {
      callback(true);
    }else{
      callback(false);
      history.push(message);
    }
  }
});

export const store = initStore({history});
registerLocales(store);

//TODO:与权限相关的privateRoute访问配置代码，暂注释掉
// export const actions = bindActionCreators({redirectToLoginWithMessage, logout}, store.dispatch);
// setupAxiosInterceptors(() => actions.redirectToLoginWithMessage('login.error.unauthorized'));

ReactDOM.render(
  <Provider store={store}>
      <div>
        {devTools}
        <ConnectedRouter history={history}>
          {getRoutes()}
        </ConnectedRouter>
      </div>
  </Provider>,
  document.getElementById('root')
);
